module.exports = __webpack_public_path__ + "static/media/don-1.3d9dbacb.png";